<template>
  <div id="supplier-quality">
    <Title :titlePage="titlePage" />
    <v-container fluid class="pa-4 pb-0">

      <div class="filter-bar">
        <v-text-field
          v-model="search"
          placeholder="Rechercher par date / N° de NC / fournisseur"
          prepend-inner-icon="mdi-magnify"
          outlined
          dense
          hide-details
          clearable
          class="filter-search"
          @input="onSearchInput"
          @click:clear="onSearchClear"
        />
        <v-btn color="#FF9900" dark @click="createNew" class="add-btn">
          <v-icon left small>fa fa-plus</v-icon>
          Ajouter une non conformité
        </v-btn>
      </div>

      <Popup
        :dialog="dialogDelete"
        text="Supprimer cette non conformité ?"
        actions=""
        heightProp=""
        widthProp=""
        showClose="false"
      >
        <v-card-actions class="mb-10">
          <v-btn color="#0B87BA" width="100px" large dark rounded @click="deleteItemConfirm">Oui</v-btn>
          <v-btn color="#0B87BA" width="100px" large dark rounded @click="dialogDelete = false">Non</v-btn>
        </v-card-actions>
      </Popup>

      <resultList
        @emitDialogRetour="openDeleteDialog"
        :header="headerRetours"
        :items="retours"
        :nbResult="displayItem"
        :type="'retours'"
        @sort="sort"
        :totalItems="totalItems"
        :page="page"
        :canModif="canModif"
        height="calc(87vh - 175px)"
      />
      <div v-if="nbPage > 1" class="pagination-bar">
        <button class="page-btn" :disabled="page === 1" @click="page--">
          <v-icon small>mdi-chevron-left</v-icon>
        </button>
        <span class="page-info">Page {{ page }} / {{ nbPage }}</span>
        <button class="page-btn" :disabled="page === nbPage" @click="page++">
          <v-icon small>mdi-chevron-right</v-icon>
        </button>
      </div>

    </v-container>
  </div>
</template>

<script>
import apiSupplierQuality from "@/api/supplier_quality";
import Popup from "@/components/shared/Popup";
import ResultList from "@/components/shared/ResultList";
import Title from "@/components/shared/Title";

export default {
  name: "SupplierQuality",
  components: { Title, ResultList, Popup },
  data() {
    return {
      titlePage: "Qualité Fournisseurs",
      search: "",
      column: "created_at",
      order: "DESC",
      page: 1,
      totalItems: 0,
      displayItem: process.env.VUE_APP_NB_DISPLAY,
      retours: [],
      nbPage: 0,
      canModif: 0,
      id_retour: 0,
      dialogDelete: false,
      searchTimeout: null,
      headerRetours: [
        { text: "N° DE NC",             align: "center", sortable: false, value: "non_compliance_fta_number" },
        { text: "FOURNISSEUR",           align: "center", sortable: true,  value: "supplier" },
        { text: "DATE FOURNISSEUR",      align: "center", sortable: true,  value: "date" },
        { text: "PRODUIT",               align: "center", sortable: false, value: "products" },
        { text: "QUANTITE",              align: "center", sortable: false, value: "product_quantity" },
        { text: "N° DE NC FOURNISSEUR",  align: "center", sortable: false, value: "non_compliance_number" },
        { text: "MATERIEL EXPEDIE",      align: "center", sortable: false, value: "need_return" },
        { text: "COUT ESTIME",           align: "center", sortable: false, value: "estimated_cost" },
        { text: "NC CLOTUREE",           align: "center", sortable: false, value: "status" },
        { text: "ACTIONS",               align: "center", sortable: false, value: "actionsSupplierQuality" },
      ],
    };
  },
  watch: {
    page() {
      this.getRetours();
    },
  },
  methods: {
    getRetours() {
      apiSupplierQuality.getSupplierQualities(this.search, this.page - 1, this.column, this.order).then((res) => {
        this.totalItems = res.data.totalItems;
        this.nbPage = res.data.totalPages;
        this.retours = res.data.rows.map(item => {
          const hasProducts = item.products && item.products.length > 0;
          return {
            ...item,
            date: item.date ? this.$moment(item.date).format("DD/MM/YYYY") : '',
            products: hasProducts
              ? item.products.map(p => (p.ref_product || '') + (p.num_product ? ' - ' + p.num_product : '')).join('\n')
              : '-',
            product_quantity: hasProducts
              ? item.products.map(p => p.article_quantite || p.quantity || '-').join('\n')
              : '-',
            need_return: item.need_return ? 'Oui' : 'Non',
          };
        });
      }).catch(() => {
        this.$store.dispatch('notify', { message: 'Erreur lors du chargement' });
      });
    },
    sort(sortEvent) {
      if (sortEvent.column !== undefined) {
        this.column = sortEvent.column;
        this.page = sortEvent.page;
      }
      if (sortEvent.order !== undefined) {
        this.order = sortEvent.order ? "ASC" : "DESC";
      }
      this.getRetours();
    },
    onSearchInput() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.page = 1;
        this.getRetours();
      }, 350);
    },
    onSearchClear() {
      this.search = "";
      this.page = 1;
      this.getRetours();
    },
    openDeleteDialog(id) {
      this.id_retour = id;
      this.dialogDelete = true;
    },
    canModified() {
      // #1124 : qualité fournisseurs en écriture (administrateurs et profil Retours)
      if (this.$portee('qualite_fournisseurs', 'ecriture') !== 'none') {
        this.canModif = 1;
      }
    },
    deleteItemConfirm() {
      apiSupplierQuality.deleteSupplierQuality(this.id_retour).then(() => {
        this.dialogDelete = false;
        this.getRetours();
      }).catch(() => {
        this.$store.dispatch('notify', { message: 'Erreur lors de la suppression' });
      });
    },
    createNew() {
      this.$router.push({ name: 'create_supplier_quality' });
    },
  },
  created() {
    this.getRetours();
    this.canModified();
  },
};
</script>

<style scoped lang="scss">
#supplier-quality {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.filter-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.filter-search {
  max-width: 400px;
}

.add-btn {
  font-weight: bold;
  text-transform: none;
}

.pagination-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 6px 0 2px;
}

.page-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 1px solid #d0d0d0;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;

  &:hover:not(:disabled) {
    background: #f0f0f0;
    border-color: #0b87ba;
  }

  &:disabled {
    opacity: 0.35;
    cursor: default;
  }
}

.page-info {
  font-size: 0.82rem;
  color: #555;
  font-weight: 500;
  min-width: 90px;
  text-align: center;
}
</style>
